import React, { ChangeEvent, PureComponent, SyntheticEvent } from 'react';
const {MDBInput} = require('mdbreact')

interface InputProps {
    id?:string;
    name?:string;
    autoComplete?:'on'|'off';
    value?:string|null;
    required?:boolean;
    error?:string|null;
    label:string;
    hint?:string;
    maxLength?:number;
    type?:string;

    readOnly?:boolean;
    disabled?:boolean;
    className?:string;
    datagridfield?: string;
    isValid?: boolean;

    onChangeHandler: (value?:string|null)=>void;

    onInput?: (evt:ChangeEvent)=>void;

    onBlur?: ()=>void;
}

interface InputState {
    oldValue?:string|null;
    value?:string|null;
    isTouched:boolean;
    error:string;
}

class Input extends PureComponent<InputProps,InputState> {
    constructor (props:InputProps) {
        super(props)

        this.state = {
            oldValue: this.props.value,
            value: this.props.value,
            isTouched: false,
            error: ''
        }
    }

    componentDidUpdate(prevProps:InputProps,prevState:InputState) {
        let props = this.props;
        let state = this.state;
        if(prevProps.value != props.value && props.value != state.oldValue && props.value != state.value) {
        this.setState({
            value: props.value,
            oldValue: props.value,
            isTouched: false,
        })
        }
    }

    onFocus = () => {
        this.setState({
            isTouched : true
        })
    }

    onBlurHandler = () => {
        if(!this.state.value) {
            this.setState({isTouched: false});
        }
        if(this.state.value != this.state.oldValue) {
          this.setState({oldValue:this.state.value},() =>{
            this.props.onChangeHandler && this.props.onChangeHandler(this.state.value);
          });
        }
        this.props.onBlur && this.props.onBlur();
    }

    onInputHandler = (e:ChangeEvent) => {
        this.setState({value: (e.target as HTMLInputElement).value});
        this.props.onInput && this.props.onInput(e);
    }

    render() {
        let id = this.props.id || this.props.name;
        if(!id){
            console.error(`Input: missing both id and name in props`, this.props);
            throw Error(`Input: missing both id and name in props`);
        }
        id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");
        let label = this.props.label;
        let active = this.state.isTouched || ![null, '', undefined, "NaN"].includes(this.state.value);
        let newlabel = this.props.datagridfield ? '' : (this.props.required || this.props.readOnly || this.props.disabled  ? label : (!active ? label + ' (optional)' : label));
        let className = "ui-mdb-input-custom " + (this.props.disabled? "disabled " : "") + (this.props.className || '');
        let hasError = !!this.props.error;
        let tabindex = this.props.readOnly ? -1 : 0;
        
        let {onChangeHandler,autoComplete, maxLength,type, hint,...otherProps} = this.props;
        delete otherProps.datagridfield;

        let autoCompleteProps = autoComplete ? {autoComplete:autoComplete} : {};

        return (
            <div className={ className}>
                <MDBInput
                    {...otherProps} // TODO: dangerous code !!!
                    {...autoCompleteProps}
                    tabIndex={tabindex}
                    value={this.state.value || ''}
                    maxLength={maxLength}
                    type={type}
                    label={newlabel}
                    hint={hint}
                    labelClass={'no-break ' + (this.props.readOnly ? 'active' : '')}
                    validate={false}
                    onInput={this.onInputHandler}
                    id={id}
                    className = {hasError ? 'is-invalid' : (this.props.isValid ? 'is-valid' : null)}
                    onFocus={this.onFocus}
                    onBlur={this.onBlurHandler}
                >
                </MDBInput>
                <div className={"valid-feedback"}></div>
                <div className={"invalid-feedback"} style={{display: hasError && !this.props.readOnly? 'block': 'none'}}>{this.props.error}</div>
            </div>
        );
    }
}


export default Input;
